import styled from 'styled-components';
import { ModalContent } from '@chakra-ui/react';

export const CompressorTypeModalContent = styled(ModalContent)`
  && {
    border-radius: 10px;
  }

  .body {
    position: relative;
    padding: 28px 24px 24px;
    background: #ffffff;
  }

  .title {
    margin-bottom: 22px;
    color: #222222;
    font-size: 21px;
    text-align: center;
  }

  .card {
    /* Ajuste aqui a altura dos quadrados que exibem os compressores. */
    min-height: 138px;
    overflow: hidden;
    border: 1px solid #009cff;
    border-radius: 5px;
    background: #ffffff;
    cursor: pointer;
    transition: box-shadow 160ms ease, transform 160ms ease;

    &:hover,
    &:focus {
      outline: none;
      box-shadow: 0 6px 18px rgba(0, 156, 255, 0.2);
      transform: translateY(-2px);
    }
  }

  .cardTitle {
    padding-top: 11px;
    color: #009cff;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
  }

  .imageWrapper {
    width: 100%;
    /* Ajuste aqui a altura da área reservada para o ícone. */
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .compressorImage {
    /* Ajuste estes valores para aumentar ou diminuir os ícones. */
    max-width: 155px;
    max-height: 95px;
    object-fit: contain;
  }

  .card--disabled {
    border-color: #c7cdd3;
    background: #f5f6f7;
    cursor: not-allowed;
    opacity: 0.45;

    &:hover,
    &:focus {
      box-shadow: none;
      transform: none;
    }

    .cardTitle {
      color: #7b848d;
    }

    .compressorImage {
      filter: grayscale(100%);
    }
  }
`;
